import * as PIXI from 'pixi.js';
import { FrameConfig } from '@/types/uiTypes';
import { Button } from '../Button';
import type { Sprite, Text } from 'pixi.js';

class ActionButton extends Button {
	enabled: boolean;
	config: FrameConfig;
	bg: Sprite | null = null;
	icon: Sprite | null = null;
	text: Text | null = null;

	constructor(obj: FrameConfig, pixiInstance: typeof PIXI) {
		super(obj);
		this.config = obj;

		this.enabled = true;

		if (obj.bg) {
			this.bg = pixiInstance.Sprite.from(pixiInstance.Texture.from(obj.bg));
			this.addChild(this.bg);
			this.bg.anchor.set(0.5, 0.5);
		}

		if (obj.icon) {
			this.icon = pixiInstance.Sprite.from(pixiInstance.Texture.from(obj.icon));
			this.bg?.addChild(this.icon);
			this.icon.anchor.set(0.5, 0.5);
		}

		if (obj.text) {
			this.text = new pixiInstance.Text(
				window.lm[obj.text].value,
				window.lm[obj.text].config
			);
			this.text?.anchor.set(0.5, 0.5);
			this.bg?.addChild(this.text);
		}

		if (!obj.bet) {
			const isTouchedDevice = window.isMobile || window.isTablet;
			this.on(
				isTouchedDevice ? 'touchendoutside' : 'mouseupoutside',
				this.mouseUpHandler.bind(this)
			);
			this.on(
				isTouchedDevice ? 'touchstart' : 'mousedown',
				this.mouseDownHandler.bind(this)
			);
			this.on(
				isTouchedDevice ? 'touchend' : 'mouseup',
				this.mouseUpHandler.bind(this)
			);
		}
	}

	toggleEnabled(state: boolean) {
		this.enabled = state;
	}

	getSize() {
		return {
			width: this.bg?.width ?? 0,
			height: this.bg?.height ?? 0
		};
	}
}

export default ActionButton;
